// Replacement for the scroll-to-element package (same call shape: a CSS selector).
export default function scrollToElement(selector) {
  const el = typeof selector === 'string' ? document.querySelector(selector) : selector;
  if (el) {
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}
